<template>
    <div class="is-flex is-justify-content-flex-end is-justify-content-flex-start-mobile mt-4">
        <b-button size="is-small" icon-left="cog" @click="initCustomActionModal" outlined :class="isCustom ? 'is-primary' : ''">
            {{ isCustom ? "Custom" : "Default" }} Actions
        </b-button>
    </div>
</template>

<script>
import StandardRuleModal from "./StandardRuleModal.vue";

export default {
    name: "StandardRuleActions",
    props: {
        ruleObj: {
            type: [Object],
        },
        title: {
            type: String,
            default: "Rule"
        }
    },
    computed: {
        isCustom(){
            return this.ruleObj.useCustomActions;
        }
    },
    methods: {
        initCustomActionModal() {
            
            this.$buefy.modal.open({
                parent: this,
                component: StandardRuleModal,
                hasModalCard: true,
                customClass: "",
                trapFocus: true,
                props: {
                    ruleObj: this.ruleObj,
                    title: this.title
                },
                events: {
                    save: (rule) => {

                        this.$emit('save', rule);
                    },
                },
            });
        }
    }
};
</script>
<style scoped>
@media (max-width: 768px) {
  .is-justify-content-flex-start-mobile {
    justify-content: flex-start !important;
  }
}
</style>